import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonLabel } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal_Application } from './Modal_ViewInvoice_Application';
import { UpdateApplicantModal} from './Modal_UpdateApplicant'

import '../../../css/layout.css';




export function Application_Details(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewApplicationDetails, setViewApplicatioDetails] = useState([]);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [viewApplicationList, setViewApplicationList] = useState([]);
    let [applicationID, setApplicationID] = useState(null);
    let [applicant_firstName, setApplicant_firstName] = useState(null);
    let [applicant_middleName, setApplicant_middleName] = useState(null);
    let [applicant_emil, setApplicant_email] = useState(null);
    let [applicant_phoneNumber, setApplicant_phoneNumber] = useState(null);
    let [applicant_addressNumber, setApplicant_addressNumber] = useState(null);
    let [applicant_streetName, setApplicant_streetName] = useState(null);
    let [applicant_city, setApplicant_city] = useState(null);
    let [applicant_cityDistrict, setApplicant_cityDistrict] = useState(null);
    let [applicant_country, setApplicant_country] = useState(null);
    let [applicant_countryRegion, setApplicant_countryRegion] = useState(null);
    let [applicant_digitalAddress, setApplicant_digitaAddress] = useState(null);
    let [applicant_dateRecieved, setApplicant_dateRecieved] = useState(null);
    let [resumeAttachement, setResumeAttachement] = useState(null);

    let [viewResumeModal, setViewResumeModal] = useState(false);
    let [applicant_staus, setApplicant_status] = useState(null);

    let [updateApplicantModal, setUpdateApplicantModal] = useState(false);


    useEffect(() => {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_application_details",
                user: acctID,
                xJobRequisitionID: props.data.requisitionID,
                xJobApplicationID: props.data.applicationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setApplicant_status(cols[18])

                setViewApplicatioDetails((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisition_id: cols[0], 
                        application_id: cols[1], 
                        requisition_name: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        applicant_address_number: cols[9], 
                        applicant_street_name: cols[10], 
                        applicant_city: cols[11], 
                        applicant_city_district: cols[12], 
                        applicant_country_region: cols[13], 
                        applicant_country: cols[14], 
                        applicant_digital_address: cols[15], 
                        attachment_resume: cols[16], 
                        date_recieved: cols[17], 
                        application_status: cols[18],
                        application_text: cols[19],

                    })
                });
            } 
        })

    }, [])   
    function viewInvoiceModalHandler(event) {


        setApplicationID(event[1]);
        setResumeAttachement(event[2]);
        setViewResumeModal(event[0]);

    }

    function handdleApplicationModal(event) {

        setApplicant_status(event[1]);
        setUpdateApplicantModal(event[0]);
    }


    function closeModalHandler() {

        setViewApplicatioDetails([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{ color: "black" }}>
            <IonGrid >

                    <IonRow>
                        <IonCol> Requisition Name</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.requisitionName} </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> Application ID</IonCol>
                        <IonCol> Applicant Name</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.applicationID} </IonCol>
                        <IonCol> {props.data.applicant_first_name + " "+props.data.applicant_last_name} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>

            {viewApplicationDetails.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow >
                    <IonCol size='3' >Category</IonCol>
                    <IonCol size='6'>Value</IonCol>
                    <IonCol size='3' >Action</IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' > Resume ID </IonCol>
                    <IonCol size='6' >{detailData.attachment_resume}</IonCol>
                    <IonCol size='3' >
                        <IonButton  onClick={() => viewInvoiceModalHandler([true, detailData.applicationID, detailData.attachment_resume])}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                        <IonCol size='3'>                        
                            <IonLabel htmlFor="mmProvider">Application Status </IonLabel>
                        </IonCol>
                        <IonCol>{detailData.application_status}</IonCol>
                        <IonCol size='3' >
                            <IonButton  onClick={() => handdleApplicationModal([true,  detailData.application_status])}> Update </IonButton>
                        </IonCol>
                    </IonRow>
                <IonRow >
                    <IonCol size='3' > Company Role </IonCol>
                    <IonCol size='6' >{detailData.company_role}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Middle Name</IonCol>
                    <IonCol size='6' >{detailData.applicant_middle_name}</IonCol>
                    <IonCol size='3' >
                     <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Phone Number</IonCol>
                    <IonCol size='6' >{detailData.applicant_phone_number}</IonCol>
                    <IonCol size='3' >
                    <IonButton > - </IonButton>
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Email Address</IonCol>
                    <IonCol size='6' >{detailData.applicant_email_address}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Address Number</IonCol>
                    <IonCol size='6' >{detailData.applicant_address_number}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Street Name</IonCol>
                    <IonCol size='6' >{detailData.applicant_street_name}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >City</IonCol>
                    <IonCol size='6' >{detailData.applicant_city}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Country</IonCol>
                    <IonCol size='6' >{detailData.applicant_country}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Country Region</IonCol>
                    <IonCol size='6' >{detailData.applicant_country_region}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p>
                                {detailData.application_text}
                        </p>
                    </IonCol>
                </IonRow>
            </IonGrid>
                    )
                }
            )}

        </IonContent>

        {viewResumeModal == true && <ViewInvoiceModal_Application openModal={ viewResumeModal } closeModal={() => setViewResumeModal(false)} data={{
                                        fileLocation: resumeAttachement, 
                                        requisitionID: props.data.requisitionID, 
                                        applicationID: props.data.applicationID, 
                                        }}></ViewInvoiceModal_Application>}
    
        {updateApplicantModal == true && <UpdateApplicantModal openModal={ updateApplicantModal } closeModal={() => setUpdateApplicantModal(false)} data={{
                                            fileLocation: resumeAttachement, 
                                            requisitionID: props.data.requisitionID, 
                                            applicationID: props.data.applicationID, 
                                            application_status: applicant_staus, 
                                            }}></UpdateApplicantModal>}


        <IonButton className='button_closeModal_center' onClick={closeModalHandler}> Close </IonButton>

    </IonModal>) : null}
    </React.Fragment>
    )
}